import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  Button,
  Card,
  Header,
  HeaderText,
  Message,
  Page,
  Shell,
  Subtitle,
  Title
} from '../components/PageTheme';

const getApiUrl = () => window.RUNTIME_CONFIG?.apiUrl || process.env.REACT_APP_API_URL;

const ContactConsent = () => {
  const { token } = useParams();
  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchInvite = async () => {
      try {
        const response = await axios.get(`${getApiUrl()}/contacts/consent/${token}`);
        setInvite(response.data);
      } catch (inviteError) {
        console.error('Error fetching invite:', inviteError);
        setError(inviteError.response?.data?.message || 'Invite not found');
      } finally {
        setLoading(false);
      }
    };

    fetchInvite();
  }, [token]);

  const respond = async (action) => {
    setSaving(true);
    setError('');
    setMessage('');

    try {
      await axios.post(`${getApiUrl()}/contacts/consent/${token}/${action}`);
      setMessage(action === 'accept'
        ? 'Accepted. You may receive accountability emails for this sender.'
        : 'Declined. You will not receive accountability emails for this sender.');
      setInvite(prevInvite => prevInvite ? {
        ...prevInvite,
        consentStatus: action === 'accept' ? 'accepted' : 'declined'
      } : prevInvite);
    } catch (responseError) {
      console.error('Error responding to invite:', responseError);
      setError(responseError.response?.data?.message || 'Failed to update invite');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Page>
      <Shell>
        <Header>
          <HeaderText>
            <Title>Accountability invite.</Title>
            <Subtitle>Choose whether PlacePledge may email you when this person misses a pledge.</Subtitle>
          </HeaderText>
        </Header>

        <Card>
          {loading ? (
            <Message>Loading invite...</Message>
          ) : error ? (
            <Message $error>{error}</Message>
          ) : (
            <>
              <p>
                {invite.senderDisplayName} wants to add {invite.emailAddress} as an accountability contact.
              </p>
              <p>
                If you accept, PlacePledge may email you when this sender misses a pledge. You can ignore this page to receive nothing.
              </p>
              {message && <Message>{message}</Message>}
              {invite.consentStatus === 'pending' ? (
                <div>
                  <Button type="button" disabled={saving} onClick={() => respond('accept')}>
                    {saving ? 'Saving...' : 'Accept'}
                  </Button>
                  <Button $secondary type="button" disabled={saving} onClick={() => respond('decline')}>
                    Decline
                  </Button>
                </div>
              ) : (
                <Message>This invite is {invite.consentStatus}.</Message>
              )}
            </>
          )}
        </Card>
      </Shell>
    </Page>
  );
};

export default ContactConsent;
